<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>What They Didn’t Teach You in Spanish Class</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<section epub:type="frontmatter" id="cont" title="Table of Contents">
<p class="h2f1"><span class="right_1" epub:type="pagebreak" id="page_3" title="3"><b>Table of Contents</b></span></p>
<p class="tocf" id="abk"><span class="hide">                  </span><a href="#/text/Book"><b>Using This Book</b></a></p>
<p class="toc" id="ch1"><a href="#/text/Chapter001">Chapter <b>1 Meet &amp; Greet</b></a></p>
<p class="toc" id="ch2"><span href="#/text/Chapter002" title="Link target outside of Sample">Chapter <b>2 Friends &amp; Enemies</b></span></p>
<p class="toc" id="ch3"><span href="#/text/Chapter003" title="Link target outside of Sample">Chapter <b>3 Booze, Bars, &amp; Clubs</b></span></p>
<p class="toc" id="ch4"><span href="#/text/Chapter004" title="Link target outside of Sample">Chapter <b>4 Sexy Body, Ugly Body</b></span></p>
<p class="toc" id="ch5"><span href="#/text/Chapter005" title="Link target outside of Sample">Chapter <b>5 Nice &amp; Naughty</b></span></p>
<p class="toc" id="ch6"><span href="#/text/Chapter006" title="Link target outside of Sample">Chapter <b>6 Smack Talk</b></span></p>
<p class="toc" id="ch7"><span href="#/text/Chapter007" title="Link target outside of Sample">Chapter <b>7 Pop Culture &amp; Technology</b></span></p>
<p class="toc" id="ch8"><span href="#/text/Chapter008" title="Link target outside of Sample">Chapter <b>8 Sports &amp; Games</b></span></p>
<p class="toc" id="ch9"><span href="#/text/Chapter009" title="Link target outside of Sample">Chapter <b>9 Food &amp; Drink</b></span></p>
<p class="tocf" id="ack"><span class="hide">                  </span><span href="#/text/Acknowledgments" title="Link target outside of Sample"><b>Acknowledgments</b></span></p>
<p class="tocf" id="aut"><span class="hide">                  </span><span href="#/text/Author" title="Link target outside of Sample"><b>About the Author</b></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?1355792b